// Validation errors messages for window.Parsley && window.Parsley
// Load this after window.Parsley && window.Parsley

window.addEventListener('load', () => {
  window.Parsley && window.Parsley.addMessages('sv', {
    dateiso: "Ange ett giltigt datum (ÅÅÅÅ-MM-DD)."
  });
});
